import { zod } from '@acme/core'
import { Abono, Ocorrencia } from 'service/api'
import { z } from 'zod'

import ApiService from '../api.service'

export type Afastamento = z.infer<typeof zod.AfastamentoSchema>

export type AfastamentoV2 = Omit<Afastamento, 'funcionarioId'> & {
    funcionarios: number[]
}

type OutputV2 = Array<(Afastamento & { Ocorrencia: Ocorrencia }) | Abono>

type Output = Afastamento & { Ocorrencia: Ocorrencia }

const service = new ApiService<Afastamento, Output>('afastamentos')

export const afastamento = Object.assign(service, {
    aprovacao: new ApiService<Afastamento, Output>('afastamentos/aprovacao'),
    reprovacao: new ApiService<Afastamento, Output>('afastamentos/reprovacao'),
})

export const afastamentoV2 = new ApiService<AfastamentoV2, OutputV2>(
    'afastamentos',
    'v2',
)
